import { ICellRendererParams } from "ag-grid-community";

import type { RequestRow } from "../requestLogGridTypes";

import { HydrationPendingCell, isRequestRowHydrating } from "./HydrationPendingCell";

import { RequestStatusBadge } from "@/components/ui/RequestStatusBadge";
import { BadgeSize } from "@/components/ui/Badge";
import { RequestLogStatus } from "@/types";

export const StatusCellRenderer = ({ data }: ICellRendererParams<RequestRow>) => {
  if (isRequestRowHydrating(data) && !data?.status) {
    return <HydrationPendingCell />;
  }
  if (!data?.status) {
    return <span className="text-gray-400">-</span>;
  }
  return (
    <RequestStatusBadge
      status={data.status as RequestLogStatus}
      size={BadgeSize.SM}
      errorType={data.error_type}
      errorMessage={data.error_message}
    />
  );
};
